export default __webpack_public_path__ + "static/photo-e7bed4290b78242aba61cc272c8d1ddf.png";